import { getAllDocumentCategory } from '@api/services/box-storage.service';
import useDataQuery from '@hooks/use-data-query';

const useCategoryListData = () => {
    const categoryListQuery = useDataQuery(['documents-category'], () => getAllDocumentCategory());

    return {
        category: categoryListQuery.data,
        isLoadingCategory: categoryListQuery.isLoading,
    };
};

export default useCategoryListData;
